/**
 * Get the host for client-side calls.
 */
export default (function () {
  return window.location.hostname;
});